import type { GeoJSONSource, Map as MapLibreMap } from 'maplibre-gl';
import { useEffect } from 'react';
import { circlePolygon } from '../../map/policies/circle-polygon';
import { trackMapRemoval } from '../adapters/track-map-removal';
import type { ZoneShapeValue } from '../policies/zone-draw-features';
import { ZONE_EDIT_RADIUS_SOURCE_ID } from '../../map/adapters/zones-map-layers';

const NOTHING: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: [] };

function previewOf({ polygon, centroid, radiusMeters }: ZoneShapeValue): GeoJSON.FeatureCollection {
  if (polygon || !centroid || !radiusMeters) return NOTHING;
  return { type: 'FeatureCollection', features: [{ type: 'Feature', geometry: circlePolygon(centroid, radiusMeters), properties: {} }] };
}

/**
 * The circle a point zone reaches, drawn on the shared map while its panel is open. terra-draw draws only the
 * centre; this follows it and the radius typed in the panel, and is cleared when the panel closes.
 */
export function useZoneRadiusPreview(map: MapLibreMap | null, shape: ZoneShapeValue) {
  const { polygon, centroid, radiusMeters } = shape;

  useEffect(() => {
    if (!map) return;
    const source = () => map.getSource<GeoJSONSource>(ZONE_EDIT_RADIUS_SOURCE_ID);
    source()?.setData(previewOf({ polygon, centroid, radiusMeters }));
    const removal = trackMapRemoval(map);
    return () => {
      if (removal.isRemoved()) return;
      removal.dispose();
      source()?.setData(NOTHING);
    };
  }, [map, polygon, centroid, radiusMeters]);
}
